import { z } from "zod"

export const coordSchema = z.object({
    longitude: z.number(),
    latitude: z.number(),
})

const orthomosaicSchema = z.object({
    fileId: z.string(),
    minLng: z.number(),
    maxLng: z.number(),
    minLat: z.number(),
    maxLat: z.number(),
    minZoom: z.number().int().nonnegative(),
    maxZoom: z.number().int().nonnegative(),
    coverageAreaM2: z.number().optional(),
})

const detectionsArtifactSchema = z.object({
    fileId: z.string(),
    count: z.number().int().nonnegative(),
})

const hotspotFeaturePropertiesSchema = z.object({
    sourceImage: z.string(),
    score: z.number(),
    peak: z.number(),
    minX: z.number(),
    maxX: z.number(),
    minY: z.number(),
    maxY: z.number(),
    area: z.number().optional(),
    point: z.tuple([z.number(), z.number()]),
})

const hotspotFeatureSchema = z.object({
    type: z.literal("Feature"),
    geometry: z.union([
        z.object({
            type: z.literal("Point"),
            coordinates: z.tuple([z.number(), z.number()]),
        }),
        z.object({
            type: z.literal("Polygon"),
            coordinates: z.array(z.array(z.tuple([z.number(), z.number()]))),
        }),
    ]),
    properties: hotspotFeaturePropertiesSchema,
})
export type HotspotFeature = z.infer<typeof hotspotFeatureSchema>

export const hotspotsGeojsonSchema = z.object({
    type: z.literal("FeatureCollection"),
    features: z.array(hotspotFeatureSchema),
})
export type HotspotsGeojson = z.infer<typeof hotspotsGeojsonSchema>

const imagesArtifactSchema = z.object({
    fileId: z.string(),
    count: z.number().int().nonnegative(),
})

export const imageMetaSchema = z.object({
    // TODO reconsider this schema
    id: z.string(),
    longitude: z.number(),
    latitude: z.number(),
    altitude: z.number(),

    height: z.number().optional(),
    pitch: z.number().optional(),
    yaw: z.number().optional(),
    roll: z.number().optional(),

    takenAt: z.number(),

    make: z.string().optional(),
    focalLength: z.number().optional(),

    size: z.number(),

    imageHeight: z.number().optional(),
    imageWidth: z.number().optional(),
    imageType: z.number().optional(),

    fov: z.array(z.number()),
})
export type ImageMeta = z.infer<typeof imageMetaSchema>
export const imagesJsonArtifactSchema = z.array(imageMetaSchema)

const runtimeTimingSchema = z.object({
    totalMs: z.number().int().nonnegative(),
    postStreamMs: z.number().int().nonnegative().nullable().optional(),
})
export type StitchRuntimeTiming = z.infer<typeof runtimeTimingSchema>

export const stitchCallbackPayloadSchema = z.object({
    orthomosaic: orthomosaicSchema.nullable().optional(),
    detections: detectionsArtifactSchema.nullable().optional(),
    images: imagesArtifactSchema.nullable().optional(),
    complete: z.boolean(),
    preview: z.boolean().optional(),
    timing: runtimeTimingSchema.nullable().optional(),
    progress: z.number().int().min(0).max(100).optional(),
})
export type StitchCallbackPayload = z.infer<typeof stitchCallbackPayloadSchema>
